import { CustomerDomainEngagement } from "../../../../state/types";

export enum CustomerDomainJiraBoardEmbedType {
    TIMELINE = "TIMELINE",
    CALENDAR = "CALENDAR"
}

export type JiraBoard = NonNullable<
    CustomerDomainEngagement["data"]
>["engagementProjects"][number]["boards"][number];

export type JiraBoardEmbedState = {
    calendarUrl: string | null;
    timelineUrl: string | null;
    selectedView: CustomerDomainJiraBoardEmbedType;
    board: JiraBoard;
    projectName: string;
    projectIcon: string;
    projectKey: string;
};

export type JiraBoardOption = {
    label: string;
    value: string;
    data: JiraBoardEmbedState;
};
